import { defaultStyles } from "@visx/tooltip";

import { tooltipContainerStyles } from "../components/Tooltip/helpers";

export const TOOLTIP_OFFSET = { top: -40, left: 10 };
export const TOOLTIP_STYLES = { ...defaultStyles, ...tooltipContainerStyles, padding: "0.8rem" };
